import React from "react";
import { Link } from "react-router-dom";
import solarImage from "../../assets/solar.png";
import "./companybanner.css";

function CompanyBanner() {
  return (
    <section className="about-section">
      <div className="container">
        <img src={solarImage} alt="Solar Panel" className="about-image" />
        <div className="about-content">
          <p className="about-sub">\ About us \</p>
          <h2 className="about-title">
            หนึ่งในวิธีที่ดีที่สุดในการผลักดันธุรกิจให้เติบโต
          </h2>
          <p className="description">
            เราช่วยให้ธุรกิจของคุณก้าวกระโดดด้วยการวางแผนที่แม่นยำ
            การออกแบบระบบที่ตอบโจทย์ และการพัฒนาที่ได้มาตรฐาน
            เพื่อให้คุณก้าวสู่ความสำเร็จอย่างมั่นใจและยั่งยืน
          </p>
          <div className="cta-box">
            <span>👤</span>
            <p>
              Get Instant <strong>Advice</strong> <br />
              <small>Ready to Help: </small>
              <a href="#">+1 356 678 7897</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CompanyBanner;
